import React, { useEffect } from 'react';
import { func, instanceOf, shape, bool } from 'prop-types';
import { connect } from 'react-redux';

import Definations from './Definations';
import ImportSelections from './ImportSelections';
import {
  getStudyTargets,
  setActiveStudyTarget,
  setSelectedDefinition,
  saveTargets,
  validateTargetLabel,
  handleChangeWeightType,
} from '../../../../actions/deActions/deImportDefActions';

const ImportDefination = ({
  setView,
  deStudies,
  getStudyTargets,
  studyDefinition,
  setActiveStudyTarget,
  setSelectedDefinition,
  saveTargets,
  validateTargetLabel,
  isLatestStudy,
  handleChangeWeightType,
}) => {
  const _getStudyTargets = study => {
    if (study) {
      getStudyTargets(study);
    }
  };

  useEffect(() => {
    _getStudyTargets(deStudies.defaultStudy);
  }, []);

  return (
    <div className="de--import-de__root de--main de--target de--flex-col de-o-hidden">
      <div className="de--row de--flex-col-1 de-o-hidden">
        <div className="de--col de--col__60 de--flex-col de-o-hidden">
          <Definations
            deStudies={deStudies}
            studyDefinition={studyDefinition}
            setActiveStudyTarget={setActiveStudyTarget}
            setView={setView}
            getStudyTargets={_getStudyTargets}
            setSelectedDefinition={setSelectedDefinition}
            isLatestStudy={isLatestStudy}
            handleChangeWeightType={handleChangeWeightType}
          />
        </div>
        <div className="de--col de--col__40 de--import-de__selections__root de--flex-col de-o-hidden">
          <ImportSelections
            selectedDefinitions={studyDefinition.selected}
            setSelectedDefinition={setSelectedDefinition}
            saveTargets={saveTargets}
            validateTargetLabel={validateTargetLabel}
          />
        </div>
      </div>
    </div>
  );
};

ImportDefination.propTypes = {
  setView: func.isRequired,
  getStudyTargets: func,
  setActiveStudyTarget: func,
  setSelectedDefinition: func,
  handleChangeWeightType: func,
  saveTargets: func,
  validateTargetLabel: func,
  isLatestStudy: bool,
  studyDefinition: shape({
    activeStudy: instanceOf(Object),
    studyTargets: {
      loading: bool,
      error: bool,
      data: instanceOf(Array),
    },
    available: instanceOf(Object),
    selected: instanceOf(Array),
    imports: instanceOf(Array),
  }),
  deStudies: shape({
    defaultStudy: instanceOf(Object),
    activeStudy: instanceOf(Object),
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
};

ImportDefination.defaultProps = {
  studyDefinition: {
    activeStudy: null,
    studyTargets: {
      loading: true,
      error: false,
      data: [],
    },
    available: null,
    selected: [],
    imports: [],
  },
};

const mapStateToProps = ({ deImportDefiniton }) => {
  return {
    studyDefinition: deImportDefiniton.studyDefinition,
    isLatestStudy: deImportDefiniton.studies.isLatestStudy,
  };
};

export default connect(mapStateToProps, {
  getStudyTargets,
  setActiveStudyTarget,
  setSelectedDefinition,
  saveTargets,
  validateTargetLabel,
  handleChangeWeightType,
})(ImportDefination);
